import React, { useEffect, useState } from "react";
import "./LoanCurrMessages.scss";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import LoanSetupTable from "../../../components/LoanSetupTable/LoanSetupTable";
import LoanSetupDetailsView from "../../../components/LoanSetupDetailsView/LoanSetupDetailsView";
import CustomLoansForm from "../../../components/UI/CustomLoansForm/CustomLoansForm";
import { commonRunQuery, listCurrencies, loansCreateCurrMessage, loansUpdateCurrMessage } from "../../../util/API/loans";
import { setNewConstants } from "../../../store/redux/constants";
import LoanLangTagsTable from "../../../components/LoanLangTagsTable/LoanLangTagsTable";

const LoanCurrMessages = ({ setAlert, setValue, setLangIdTableData, setFromTab, setAlertOpen }) => {
    const [viewMode, setViewMode] = useState("table");
    const [loanCurrMsgArr, setLoanCurrMsgArr] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [loanCurrencyArr, setLoanCurrencyArr] = useState([]);
    // const [langIdTableData, setLangIdTableData] = useState([]);

    const dispatch = useDispatch();

    const columns = [
        {
            label: 'Loan Product Id',
            getValue: (row) => row?.lcm?.LoanProductId ?? ''
        },
        {
            label: 'Loan Product',
            getValue: (row) => row?.lp?.LoanProduct ? row?.lp?.LoanProduct : '-'
        },
        {
            label: 'Flag Message LangId',
            getValue: (row) => row?.lcm?.FlagMessageLangId ?? '',
            hidden: true,
        },
        {
            label: 'Block Message LangId',
            getValue: (row) => row?.lcm?.BlockMessageLangId ?? '',
            hidden: true,
        },
        {
            label: 'Stop Opt Out On Outstanding Balance',
            getValue: (row) => row?.lcm?.StopOptOutOnOutstandingBalance ?? ''
        },
        {
            label: 'Payment Confirmed Initial Stat',
            getValue: (row) => row?.lcm?.PaymentConfirmedInitialStat ?? ''
        },
        {
            label: 'Real Time Score Status',
            getValue: (row) => row?.lcm?.RealTimeScoreStatus ?? ''
        },
        {
            label: 'Real Time Score Module',
            getValue: (row) => row?.lcm?.RealTimeScoreModule || '-'
        },
        {
            label: 'Real Time Score Gateway Id',
            getValue: (row) => row?.lcm?.RealTimeScoreGatewayId || '-'
        },
        {
            label: 'Loan Issued Reconciliation Module',
            getValue: (row) => row?.lcm?.LoanIssuedReconciliationModule ?? '-',
            hidden: true,
        },
        {
            label: 'Loan Payment Reconciliation Module',
            getValue: (row) => row?.lcm?.LoanPaymentReconciliationModule ?? '-',
            hidden: true,
        },
        {
            label: 'Country Code',
            getValue: (row) => row?.lcm?.CountryCode ?? '-',
            hidden: true,
        },
        {
            label: 'Is Default OptIn',
            getValue: (row) => row?.lcm?.IsDefaultOptIn ?? '-',
            hidden: true,
        },
        {
            label: 'Late Fee Calculation Mode',
            getValue: (row) => row?.lcm?.LateFeeCalculationMode ?? '-',
            hidden: true,
        },
        {
            label: 'Loan Repayment LangId',
            getValue: (row) => row?.lcm?.LoanRepaymentLangId ?? '-',
            hidden: true,
        },
        {
            label: 'Notification Last Day',
            getValue: (row) => row?.lcm?.NotificationLastDay ?? '-',
            hidden: true,
        },
        {
            label: 'Loan OptIn Module',
            getValue: (row) => row?.lcm?.LoanOptInModule ?? '-',
            hidden: true,
        },
        {
            label: 'Loan OptOut Module',
            getValue: (row) => row?.lcm?.LoanOptOutModule ?? '-',
            hidden: true,
        },
        {
            label: 'Loan Notification Module',
            getValue: (row) => row?.lcm?.LoanNotificationModule ?? '-',
            hidden: true,
        },
        {
            label: 'Loan Payment Reconciliation Module 2',
            getValue: (row) => row?.lcm?.LoanPaymentReconciliationModule2 ?? '-',
            hidden: true,
        },
        {
            label: 'Loan Issued Reconciliation Module 2',
            getValue: (row) => row?.lcm?.LoanIssuedReconciliationModule2 ?? '-',
            hidden: true,
        },
        {
            label: 'Balance Check',
            getValue: (row) => row?.lcm?.BalanceCheck ?? '-',
            hidden: true,
        }
    ];

    useEffect(()=> {
        getAllLoanCurrMessages();
        getAllLoanCurrencies();
    }, []);

    useEffect(()=> {
        dispatch(setNewConstants({ formSelectData: { loancurr:loanCurrencyArr } }));
    },[loanCurrencyArr]);

    const getAllLoanCurrMessages = async () => {
        try {
            let response = await commonRunQuery(278, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const currMsgArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                setLoanCurrMsgArr(currMsgArray);
                console.log("currMsgArray=======================", currMsgArray);
            } else {
                setLoanCurrMsgArr([]);
            }
        } catch (error) {
            console.log("getAllLoanCurrMessages_error=======================", error);
        }
    };

    const getAllLoanCurrencies = async () => {
        try {
            // let response = await listCurrencies("EN");
            let response = await commonRunQuery(223,"");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const rawCurrencies = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedCurrencies = rawCurrencies.map((item) => {
                    const v = item.loanproducts;
                    return {
                        key: v.productid,
                        value: v.productid,
                        label: v.name,
                    };
                });
    
                setLoanCurrencyArr(formattedCurrencies);
                console.log("formattedCurrencies=======================", formattedCurrencies);
            } else {
                setLoanCurrencyArr([]);
            }
        } catch (error) {
            console.log("getAllLoanCurrencies_error=======================", error);
        }
    };

    const handleEdit = (rowData) => {
        console.log("handleEdit_rowData=======================", rowData);
        setSelectedRowData(rowData);
        setViewMode("edit")
        // setSelectedLanguage(rowData);
    }

    const handleSubmit = async(submittedValue) => {
        console.log("handleSubmit_submittedValue=======================", submittedValue);
        try {
            const response = await loansCreateCurrMessage(
                "",
                submittedValue?.loancurr,
                submittedValue?.stopoptoutonoutstandingbalance,
                submittedValue?.paymentconfirmedinitialstat,
                submittedValue?.realtimescorestatus,
                submittedValue?.realtimescoremodule,
                submittedValue?.realtimescoregatewayid,
                submittedValue?.loanissuedreconciliationmodule,
                submittedValue?.loanpaymentreconciliationmodule,
                submittedValue?.countrycode,
                submittedValue?.loanoptinmodule,
                submittedValue?.latefeecalculationmode,
                submittedValue?.notificationlastday,
                submittedValue?.isdefaultoptin,
                submittedValue?.loanoptoutmodule,
                submittedValue?.loannotificationmodule,
                submittedValue?.balancecheck,
                submittedValue?.loanpaymentreconciliationmodule2,
                submittedValue?.loanissuedreconciliationmodule2,
                submittedValue?.flagmessagelangid,
                submittedValue?.blockmessagelangid,
                submittedValue?.loanrepaymentlangid,
            );

            console.log("handleSubmit_response----------------", response)
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan currency message created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanCurrMessages();
                setViewMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating loan currency message. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleUpdate = async(submittedValue) => {
        console.log("handleUpdate_submittedValue=======================", submittedValue);
        try {
            const response = await loansUpdateCurrMessage(
                "",
                submittedValue?.loancurr,
                submittedValue?.stopoptoutonoutstandingbalance,
                submittedValue?.paymentconfirmedinitialstat,
                submittedValue?.realtimescorestatus,
                submittedValue?.realtimescoremodule,
                submittedValue?.realtimescoregatewayid,
                submittedValue?.loanissuedreconciliationmodule,
                submittedValue?.loanpaymentreconciliationmodule,
                submittedValue?.countrycode,
                submittedValue?.loanoptinmodule,
                submittedValue?.latefeecalculationmode,
                submittedValue?.notificationlastday,
                submittedValue?.isdefaultoptin,
                submittedValue?.loanoptoutmodule,
                submittedValue?.loannotificationmodule,
                submittedValue?.balancecheck,
                submittedValue?.loanpaymentreconciliationmodule2,
                submittedValue?.loanissuedreconciliationmodule2,
                submittedValue?.flagmessagelangid,
                submittedValue?.blockmessagelangid,
                submittedValue?.loanrepaymentlangid,
            );

            console.log("handleUpdate_response----------------", response)
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan currency message updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);
                
                getAllLoanCurrMessages();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating loan currency message. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleViewDetails = async(rowData) => {
        console.log("handleViewDetails_rowData=======================", rowData);
        setSelectedRowData(rowData?.lcm);
        setViewMode("view")
    }

    const handleLangIdClick = async(langIdData) => {
        console.log("langIdData=======================", langIdData);
        // setViewMode("viewLangIdTable");
        try {
            const response = await commonRunQuery(275,langIdData);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const langIdDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
                setLangIdTableData(langIdDataArray);
                setFromTab("LoanCurrMessages")
                console.log("langIdDataArray=======================",langIdDataArray);
                setValue(4);
            } else {
                setLangIdTableData([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box sx={{ p: 2 }} className="loan-curr-msg-container">
            {viewMode === "table" && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            Loan Product Message
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("create");
                            }}
                        >
                            Create Loan Currency Message
                        </Button>
                    </Box>

                    <LoanSetupTable
                        data={loanCurrMsgArr}
                        columns={columns}
                        title="Loan Currency Message"
                        formatRow = {formatedRows}
                        isEdit={true}
                        handleEdit={handleEdit}
                        viewDetails={true}
                        handleViewDetails={handleViewDetails}
                    />
                </Box>
            )}

            {viewMode === "view" && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table");
                                setSelectedRowData(null);
                            }}
                        >
                            Return
                        </Button>
                    </Box>
                    <LoanSetupDetailsView title={"Loan Currency Details"} data={selectedRowData} formName={"createloancurrmsg"} handleLangIdClick={handleLangIdClick} />
                </Box>
            )}

            {(viewMode === "create" || viewMode === "edit")  && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table");
                                setSelectedRowData(null);
                            }}
                        >
                            Return
                        </Button>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 800, mt: 2 }}>
                        <CustomLoansForm
                            formValues={null}
                            formName={"createloancurrmsg"}
                            buttonText={viewMode === "edit" ? "Update" : "Submit"}
                            loadingButtonText={viewMode === "edit" ? "Updating Currency Message ..." : "Creating Currency Message ..."}
                            onSubmit={viewMode === "create" ? handleSubmit : handleUpdate}
                            initialValues={{
                                loancurr: selectedRowData?.lcm?.LoanProductId,
                                stopoptoutonoutstandingbalance: selectedRowData?.lcm?.StopOptOutOnOutstandingBalance,
                                paymentconfirmedinitialstat: selectedRowData?.lcm?.PaymentConfirmedInitialStat,
                                realtimescorestatus: selectedRowData?.lcm?.RealTimeScoreStatus,
                                realtimescoremodule: selectedRowData?.lcm?.RealTimeScoreModule,
                                realtimescoregatewayid: selectedRowData?.lcm?.RealTimeScoreGatewayId,
                                loanissuedreconciliationmodule: selectedRowData?.lcm?.LoanIssuedReconciliationModule,
                                loanpaymentreconciliationmodule: selectedRowData?.lcm?.LoanPaymentReconciliationModule,
                                countrycode: selectedRowData?.lcm?.CountryCode,
                                loanoptinmodule: selectedRowData?.lcm?.LoanOptInModule,
                                latefeecalculationmode: selectedRowData?.lcm?.LateFeeCalculationMode,
                                notificationlastday: selectedRowData?.lcm?.NotificationLastDay,
                                isdefaultoptin: selectedRowData?.lcm?.IsDefaultOptIn,
                                loanoptoutmodule: selectedRowData?.lcm?.LoanOptOutModule,
                                loannotificationmodule: selectedRowData?.lcm?.LoanNotificationModule,
                                balancecheck: selectedRowData?.lcm?.BalanceCheck,
                                loanpaymentreconciliationmodule2: selectedRowData?.lcm?.LoanPaymentReconciliationModule2,
                                loanissuedreconciliationmodule2: selectedRowData?.lcm?.LoanIssuedReconciliationModule2,
                                flagmessagelangid: selectedRowData?.lcm?.FlagMessageLangId,
                                blockmessagelangid: selectedRowData?.lcm?.BlockMessageLangId,
                                loanrepaymentlangid: selectedRowData?.lcm?.LoanRepaymentLangId,
                            }}
                            // isCreate={true}
                            isEdit={viewMode == "edit" ? true : false}
                            isCreate={viewMode == "create" ? true : false}
                        />
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default LoanCurrMessages;
